module.exports = __webpack_public_path__ + "img/cenefa.d9111ab9.png";